import jwtDecode from "jwt-decode";
import { getInstance } from "./index";

// Permisiunile cerute de ruta (meta.permissions), comparate cu TOATE permisiunile din tokenul de acces, nu doar
// cu prima (spec E, 5.2). Nu depinde de store, care se completeaza abia dupa pornirea App.vue.
// Protectia reala ramane API-ul; guard-ul da un refuz clar in locul unui ecran gol.
export const hasAnyPermission = (tokenPermissions, required) => {
  const granted = (tokenPermissions || []).map((permission) =>
    String(permission).toLowerCase()
  );
  return (required || []).some(
    (permission) => granted.indexOf(String(permission).toLowerCase()) !== -1
  );
};

const whenLoaded = (authService) =>
  new Promise((resolve) => {
    if (!authService.loading) {
      resolve();
      return;
    }
    const stop = authService.$watch("loading", (isLoading) => {
      if (isLoading === false) {
        stop();
        resolve();
      }
    });
  });

export const permissionGuard = async (to, from, next) => {
  const authService = getInstance();
  await whenLoaded(authService);

  if (!authService.isAuthenticated) {
    authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
    return;
  }

  const required = (to.meta && to.meta.permissions) || [];
  if (required.length === 0) {
    next();
    return;
  }

  try {
    const token = await authService.getTokenSilently();
    if (hasAnyPermission(jwtDecode(token).permissions, required)) {
      next();
      return;
    }
  } catch (error) {
    // tokenul nu a putut fi obtinut sau decodat: accesul se refuza
  }
  next({ name: "forbidden" });
};
